// extracted by mini-css-extract-plugin
export default {"stylizedContent":"xscrolleasy_stylizedContent__NdBL2","xscollContent":"xscrolleasy_xscollContent__NH4Ud"};